import * as React from 'react';
interface IConditionalProps {
    visible:boolean;
    children?: React.ReactNode;
}

export class Conditional extends React.Component<IConditionalProps,{}> {
    render() {
        if (!this.props.visible) return null;
        return <>{this.props.children}</>;
    }
}